// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 12 12">
            <defs>
                <path id="a" d="M0 0h12v12H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M10.205 8.922h.412c.763 0 1.383-.62 1.383-1.383V4.461c0-.763-.62-1.383-1.383-1.383h-.925V1.383C9.692.62 9.072 0 8.308 0H3.692C2.93 0 2.308.62 2.308 1.383v1.695h-.925C.62 3.078 0 3.698 0 4.461V7.54c0 .762.62 1.383 1.383 1.383h.412v1.695c0 .763.621 1.383 1.383 1.383h5.644c.762 0 1.383-.62 1.383-1.383V8.922Zm-7.182-7.54c0-.368.3-.667.67-.667h4.615c.37 0 .67.3.67.668v1.695H3.022V1.383Zm6.467 9.235c0 .369-.3.669-.668.669H3.178a.67.67 0 0 1-.669-.67V6.614h6.98v4.004Zm.358-4.718H2.152a.358.358 0 0 0-.357.358v1.951h-.412a.67.67 0 0 1-.669-.669V4.461c0-.368.3-.669.67-.669h9.233c.37 0 .669.3.669.67v3.077a.67.67 0 0 1-.67.67h-.411V6.256a.358.358 0 0 0-.357-.358Z"
                    mask="url(#b)"
                />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M8.052 10.205a.357.357 0 0 0 0-.715H3.948a.357.357 0 0 0 0 .715h4.104Zm0-1.796a.357.357 0 0 0 0-.715H3.948a.357.357 0 0 0 0 .715h4.104Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Print);
